/* eslint-disable */
var icon = require('vue-svgicon');
icon.register({
    'segmented-nav': {
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
        data: '<path pid="0" d="M0 6a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H2a2 2 0 01-2-2zm6 3h4V5H6zm9-1V6a1 1 0 00-1-1h-3v4h3a1 1 0 001-1"/>',
    },
});
